import React, { FC } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'

import { Notifications } from '@infologistics/frontend-libraries'

import { authRoutes, registerRoutes } from '@app/routes'
import { getRoutesList } from '@utils/utils'

import { RedirectToStartPage } from '@common/Routing'

import AppLayout from '@common/Layout/components/AppLayout'
import LoginLayout from '@app/views/auth/components/LoginLayout'

const LayoutRouter: FC = () => (
  <BrowserRouter>
    <Notifications />
    <Routes>
      <Route index element={<RedirectToStartPage />} />

      {getRoutesList(registerRoutes)}
      <Route element={<LoginLayout />}>
        {getRoutesList(authRoutes)}
      </Route>
      <Route path='*' element={<AppLayout />} />
    </Routes>
  </BrowserRouter>
)

export default LayoutRouter
